<template>
  <div class="layout">
    <div class="layout-menu">
      <!-- 页面顶部站点logo -->
      <div class="logo" @click="first_menu_collapse = !first_menu_collapse">
        <el-image :src="shopInfo.store_logo || require('@/assets/user.png')"></el-image>
      </div>
      <!-- 页面顶部站点logo结束 -->
      <!-- 页面左侧一级菜单 -->
      <el-menu :collapse="first_menu_collapse" class="el-menu-vertical-demo" router background-color="#010E27"
        text-color="#fff" active-text-color="#fff">
        <el-menu-item :class="[
              'center',
              activeFirstMenu.path == item.path ? 'el-menu-item-active' : '',
            ]" :index="item.path" v-for="item in routers" :key="item.path" :route="item.path">
          <img :src="item.meta.icon" style="width: 24px; margin-right: 8px" alt="" />
          <span slot="title">{{ item.meta.name }}</span>
        </el-menu-item>
      </el-menu>
      <!-- 页面左侧一级菜单结束 -->
    </div>

    <!-- 左侧二级菜单 -->
    <div class="child_menu" :style="{ width: nowIsShowFunctionArea ? '230px' : '1px' }">
      <div v-if="activeFirstMenu != '/'" :class="['switch_button', !nowIsShowFunctionArea ? 'open_btn' : '']"
        @click="show_quick_function_area = !show_quick_function_area">
        <div v-if="nowIsShowFunctionArea" class="btn center">《</div>
        <div v-if="!nowIsShowFunctionArea" class="btn center">》</div>
      </div>
    </div>
    <!-- 左侧二级菜单结束 -->
    <div class="menu-content">
      <div class="view-title">
        <div v-if="activeFirstMenu.path === '/'"></div>
        <div v-if="activeFirstMenu.path !== '/'" class="show_second_menu">
          <div class="show_second_menu_box" v-for="menu in nowRouterSecondChildrenMenu" :key="menu.path">
            <div class="show_second_menu_box" v-if="menu.meta.rules">
              <div v-if="!menu.children" @click="jumpRouter(menu)" :class="[
                      'second_menu',
                      'center',
                      activeSecondMenu.path == menu.path || activeSecondMenu.meta.relation == menu.name ? 'active_second_menu' : '',
                    ]">
                {{ menu.meta.name }}
              </div>
              <el-dropdown @command="jumpThirdMenu" v-if="menu.children">
                <div @click="jumpRouter(menu)" :class="[
                        'second_menu',
                        'center',
                        activeSecondMenu.path == menu.path || activeSecondMenu.meta.relation == menu.name ? 'active_second_menu' : '',
                      ]">
                  {{ menu.meta.name }}
                </div>
				<!-- .map(i=>i.meta.rules) -->
                <el-dropdown-menu slot="dropdown" v-if="menu.children">
                  <el-dropdown-item class="third_menu" v-for="t_menu in menu.children.filter(i=> i.meta.rules == 1 )" :key="t_menu.path"
                    :command="t_menu" :style="{
                          color:activeThirdMenu.path == t_menu.path || activeThirdMenu.meta.relation == t_menu.name ? '#1467ff' : '',
                          backgroundColor:activeThirdMenu.path == t_menu.path || activeThirdMenu.meta.relation == t_menu.name? '#f0f4ff' : '',
                        }">{{ t_menu.meta.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="userInfo">
          <div class="tips">
            <!-- 消息喇叭 -->
            <el-popover placement="bottom-end" width="485" :offset="130" trigger="click" @after-enter="showNotice">
              <template>
                <NoticeListTabs ref="NoticeListTabs" @removeMsg="getMsgCount"></NoticeListTabs>
              </template>
              <div slot="reference">
                <!--  -->
                <el-badge :value="msgCount" :hidden="msgCount == 0">
                  <i class="iconfont iconxiaoxi14"></i>
                </el-badge>
              </div>
            </el-popover>
          </div>
          <el-dropdown class="userName" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="iconfont icon-guanliyuan"></i>
              {{ userInfo.staff_account || "admin" }}
              <i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="shop">返回站点</el-dropdown-item> -->
              <el-dropdown-item command="outLogin">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div ref="router_view" class="router-view">
        <router-view ref="rightBot" :key="$route.fullPath"></router-view>
        <!-- <div class="t_logo" v-show="!is_form">
              <el-image
                style="width: 50px"
                :src="require('@/assets/zhongcha_logo.png')"
              ></el-image>
            </div> -->
      </div>
    </div>
    <!-- 播放音频 -->
    <audio ref="audio" src="@/assets/audio/neworderTZ.mp3"></audio>
  </div>
</template>
  
  <script>
import { getDateformat } from "@/util/getDate.js";
import { path } from "@/util/config.js";
import NoticeListTabs from "@/components/noticeListTabs.vue";
import { color } from "echarts";
export default {
  components: {
    NoticeListTabs,
  },
  data() {
    return {
      first_menu_collapse: false,
      show_quick_function_area: false,
      color: "red",
      getDateformat,
      shwoPageName: "",
      is_form: "",
      socket: null,
      socketArr: [],
      path,
      audio: null,
      end_time: null,
      store_type: "",
      showPageName: !0,
      msgCount: 0,
      showSwitch: !1,
      siteList: [],
      total_site: 0,
    };
  },
  watch: {
    activeFirstMenu: {
      handler(val) {
        if (val == "/") {
          this.show_quick_function_area = false;
        }
      },
      immediate: true
    }
  },
  created() {
    this.$store.dispatch("user/getShopInfo");
    if (typeof WebSocket === "undefined") {
      this.$message.error("您的浏览器不支持socket");
    }
    let token = sessionStorage.getItem("token");
    this.path += token;
    this.routers.map((item) => {
      if (item.path == "/") {
        this.socket = new WebSocket(this.path);
        this.socket.onopen = this.open;
        this.socket.onmessage = this.getMessage;
        this.socket.onclose = this.close;
      }
    });
  },
  mounted() {
    if (this.socket) {
      this.audio = this.$refs.audio;
    }
    this.end_time = getDateformat(
      Number(localStorage.getItem("uniac_endtime"))
    );
    this.store_type = localStorage.getItem("store_type");
    let a = document.createElement("div");
    a.id = "download";
    document.body.appendChild(a);
    a.click();
    let aDom = document.getElementById("download");
    document.body.removeChild(aDom);
  },
  computed: {
    // 当前高亮的一级菜单
    activeFirstMenu() {
      if (this.$route.path == '/index') {
        return { path: '/', meta: { name: '首页' } }
      }
      return this.$route.matched[0] ? this.$route.matched[0] : { meta: { name: '' } }
    },
    // 当前高亮的二级菜单
    activeSecondMenu() {
      return this.$route.matched[1] ? this.$route.matched[1] : { meta: { name: '' } }
    },
    // 当前高亮的三级菜单
    activeThirdMenu() {
      return this.$route.matched[2] ? this.$route.matched[2] : { meta: { name: '' } }
    },
    // 该站点所有的路由信息
    routers() {
      return this.$store.getters.menuLeft;
    },
    // 当前路由层级信息
    // 当前一级路有所包含的二级路由
    nowRouterSecondChildrenMenu() {
      let arr = [];
      if (!this.routers.length) return arr;
      arr = this.routers.find((i) => i.path == this.activeFirstMenu.path).children;
      if (arr && !arr.length) return arr.filter(i => i.meta.rules)
      return arr;
    },
    // 当前二级路由有所包含的三级路由
    nowRouterThirdChildrenMenu() {
      let arr = [];
      if (!this.routers.length) return arr;
      arr = this.nowRouterSecondChildrenMenu.find((i) => i.path == this.activeSecondMenu.path).children;
      if (arr && !arr.length) return arr.filter(i => i.meta.rules)
      return arr;
    },
    nowIsShowFunctionArea() {
      return this.show_quick_function_area;
    },
    // 登录的用户信息
    userInfo() {
      return this.$store.getters.userInfo;
    },
    // 站点过期时间
    siteEndTime() {
      return this.$store.getters.siteEndTime;
    },
    // 用户的店铺信息
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
    // 不显示的菜单
    relationMenu() {
      return this.$store.getters.relationMenu;
    },
  },
  methods: {
    // 点击二级菜单 跳转路由
    jumpRouter(menu) {
      if (this.activeSecondMenu.path !== menu.path) {
        this.$router.push(menu.path);
      }
    },
    jumpThirdMenu(menu) {
      if (this.activeThirdMenu.path !== menu.path) {
        this.$router.push(menu.path);
      }
    },
    handleCommand(val) {
      sessionStorage.clear();
      if (val == "shop") {
        this.$store.dispatch("user/backProgram", {
          uniacid: localStorage.getItem("u_id"),
        });
      }
      if (val == "outLogin") {
        this.outLogin();
      }
    },
    // 开启websocket
    open() {
    },
    // websocket 监听消息
    getMessage(data) {
      let res = JSON.parse(data.data);
      if (res.type != undefined) {
        let path1 = this.toDealMsg(res.type);
        this.$set(res, "path", path1);
        this.socketArr.push(res);
        this.msgCount++;
        if (
          this.$route.path == "/index" ||
          this.$route.path == "/repair/index"
        ) {
          this.$refs.rightBot.indexData.message.push({
            content: res.message,
            create_time: res.create_time,
            type: res.type,
          });
          // this.msgCountMethod()
        }
        if (res.type == 1) {
          this.audio.play();
          this.msgBox(res);
        }
      }
    },
    // 关闭websocket
    close() {
    },

    // 筛选去处理的跳转路径
    toDealMsg(index) {
      if (index == 6) {
        this.$message({
          message: "暂未开放客服模块",
          type: "warning",
        });
        return "";
      }
      let path2 = "";
      let case_id = localStorage.getItem("case_id");
      switch (index) {
        case 1:
          path2 =
            case_id == 15
              ? "/repair/goods/orderlist?tab_type=state_pay"
              : "/order/orderList?tab_type=state_pay";
          break;
        case 2:
          path2 =
            case_id == 15
              ? "/repair/goods/salelist?type=1"
              : "/order/salesRefund";
          break;
        case 3:
          path2 = `/store/storeManagement?id=${index.store_id}`;
          break;
        case 4:
          path2 = `/store/reflectAudit?id=${index.store_id}`;
          break;
        case 5:
          path2 = "/set/weixin?from=1";
          break;
        case 6:
          path2 = "";
          break;
        case 7:
          path2 =
            case_id == 15 ? "/repair/goods/evaluate" : "/goods/GoodsEvaluate";
          break;
        case 8:
          path2 = "/user/userList";
          break;
        case 9:
          path2 = "/user/userList";
          break;
        case 10:
          path2 = "/user/userList";
          break;
        default:
          break;
      }
      return path2;
    },
    // 右侧弹出消息提示
    msgBox(res) {
      let that = this;
      const notify = this.$notify({
        duration: 3000,
        dangerouslyUseHTMLString: true,
        message: `<div class='msgBox' style='display:flex;justify-content:space-between;align-items: center;'><div><img style='width:40px;height:40px;border-radius:50%' src='${res.avatar
          }' /></div><div style=" max-width:270px; margin:0 24px 0 20px;display: flex;flex-direction: column;justify-content: space-around;"><div style='margin-bottom:5px'><b>【${res.type == 1 ? "新订单通知" : ""
          }】</b></div><div style='margin-left:4px;text-align:left;font-size:14px'>
          <p>用户[<span style='color:#5654F3'>${res.nickname.substring(
            0,
            1
          )}***${res.nickname.substring(
            res.nickname.length - 1
          )}</span>]下了新的订单,请及时处理！</p>
          <p>订单号:${res.message.substring(14, 36)}</p>
          </div></div><div style='font-size:12px;flex-shrink: 0;text-align: center;width: 56px;height: 28px;line-height: 28px;color:#fff;background:#5654F3;cursor: pointer;' id='btnDeal' >处理<div></div>`,
      });
      // 给通知中的按钮注册事件
      notify.$el.querySelector("#btnDeal").onclick = () => {
        notify.close();
        that.$router.push({
          path: `${res.path}`,
        });
      };
    },
    // 判断该路由是否需要显示子菜单
    isShowSonMenu() {
      let noArr = ["/index", "/upRenew", "/repair/index"];
      let res = noArr.find((item) => item === this.$route.path);
    },
    //退出登录
    outLogin() {
      let that = this;
      this.$store.dispatch("user/outLogin", {
        success() {
          that.socket.close();
        },
      });
    },
    showNotice() {
      this.$nextTick(() => {
        this.$refs.NoticeListTabs.showFirst();
      });
    },
  },
};
  </script>
  
  <style lang="less" scoped>
@test: color;

.color {
  color: @test;
}

#switch {
  display: flex;
  align-items: center;

  .store_logo {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 50%;
  }

  span {
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .img {
    width: 15px;
    height: 15px;
    margin-left: 10px;
  }
}
.layout {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  display: flex;

  .layout-menu {
    width: fit-content;
    height: 100%;
    background: #010e27;
    color: #fff;

    .logo {
      text-align: center;
      margin: 0 auto;
      margin: 16px auto;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      position: relative;
      color: #2e2e2e;

      .el-image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }

    .el-menu {
      border: none;
      &:not(.el-menu--collapse) {
        width: 120px;
      }
      .el-menu-item {
        height: 50px;
        line-height: 50px;
        width: 100%;
        padding: 0 !important;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          color: #fff;
          margin-right: 5px;
          font-size: 17px;
        }
      }

      .el-menu-item-active {
        background: #1467ff !important;
      }
    }
  }

  .child_menu {
    height: 100%;
    background: #fff;
    transition: left 0.2s;
    flex-shrink: 0;
    position: relative;
    .switch_button {
      width: 28px;
      height: 28px;
      position: absolute;
      top: 50%;
      right: 0;
      z-index: 1;
      display: flex;
      justify-content: flex-end;
      transform: translateY(-50%);
      .btn {
        width: 14px;
        height: 28px;
        background-color: silver;
        color: #fff;
        font-size: 12px;
        border-radius: 5px 0 0 5px;
        transform: all 0.8s;
        cursor: pointer;
        &:hover {
          width: 18px;
        }
      }
    }
    .open_btn {
      right: -14px;
      &:hover {
        right: -18px;
      }
      .btn {
        border-radius: 0 5px 5px 0;
      }
    }
  }
  .menu-content {
    flex: 1;
    width: 0;
    background: #f8f8fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;

    .view-title {
      flex: 0 0 66px;
      background: #fff;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px 0 15px;
      font-size: 14px;
      box-shadow: 0 1px 4px rgb(216, 206, 206);

      .show_second_menu {
        flex: 1;
        height: 95%;
        margin-right: 40px;
        display: flex;
        align-items: stretch;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
        .show_second_menu_box,
        .el-dropdown {
          height: 100%;
        }
        .second_menu {
          height: 100%;
          padding: 0 28px;
          border-radius: 8px 8px 0 0;
          font-size: 15px;
          font-weight: 500;
          color: #222;
          cursor: pointer;
          &:hover {
            color: #1467ff;
            background: rgba(240, 244, 255, 0.5);
          }
        }
        .active_second_menu {
          color: #1467ff;
          border-bottom: 2px solid #1467ff;
          background: #f0f4ff !important;
        }
      }

      .userInfo {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        .tips {
          margin-right: 25px;
        }

        .userName {
          cursor: pointer;
        }

        .outLogin {
          cursor: pointer;
          margin-right: 20px;
        }
      }

      .upRenew {
        display: inline-block;
        font-size: 12px;
        line-height: 14px;
        background-color: #faebcf;
        color: #754815;
        padding: 4px 10px;
        user-select: none;
        cursor: pointer;
      }
    }

    .router-view {
      flex: 1;
      padding: 15px 15px 0 15px;
      overflow-y: auto;
      box-sizing: border-box;
      width: 100%;
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      .t_logo {
        text-align: center;
        margin: 20px 0;
      }
    }
  }
}

.el-notification {
  width: 440px !important;
  padding: 16px 24px !important;

  & > div {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;

    .el-notification__closeBtn {
      top: 8px !important;
      right: 8px !important;
    }
  }

  .el-notification__content {
    margin-top: 0px;
  }
}

.el-main {
  width: 100%;
}

.SName {
  display: inline-block;
  background-color: #1467ff;
  color: #fff;
  font-size: 14px;
  padding: 2px 10px;
  margin-right: 10px;
}

.el-dropdown-menu .third_menu:hover {
  color: #1467ff !important;
  background: rgba(240, 244, 255, 0.5) !important;
}
</style>
  